export default (params) => ({
  trigger: {
    name: 'store_stock_overlay.select_more_less_opening_times',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          'more',
          'less',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'opening_times',
      },
    },
    nonInt: true,
  },
});
